import React from 'react';
import { useAppSelector } from '../../hooks';
import { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { beansIndex } from '../../wrappers/subgraph';
import classes from './Verify.module.css';
import clsx from 'clsx';
import Section from '../../layout/Section';
import { Button, Col, Form } from 'react-bootstrap';
import VerifySignature from '../../components/VerifySignature';
import * as R from 'ramda';
import { useSignMessage } from 'wagmi';

interface VerifyPageProp {}

export default function VerifyPage(props: VerifyPageProp) {
  const activeAccount = useAppSelector((state) => state.account.activeAccount);
  const { data } = useQuery(beansIndex());
  const [messageToSign, setMessageToSign] = useState<undefined | string>(
    undefined
  );
  const [signedMessage, setSignedMessage] = useState<undefined | object>(
    undefined
  );

  const { signMessageAsync } = useSignMessage();

  const extractOwnedBeanIdsFromBeansIndex = (
    owner: string | undefined,
    beansIndex: any
  ) =>
    R.pipe(
      (beans: any) =>
        beans.filter((bean: any) =>
          !owner
            ? false
            : (bean.owner.id as string)
                .toLocaleLowerCase()
                .localeCompare(owner.toLocaleLowerCase()) === 0
        ),
      R.map((bean: any) => Number(bean.id)),
      R.sort((a: number, b: number) => a - b)
    )(beansIndex.beans);

  const loadingContent = () => (
    <div className={classes.loadingContent}>LOADING YOUR BEANS...</div>
  );

  useEffect(() => {
    if (!data) return;
    const initialMessage = (beans: number[]) =>
      [
        activeAccount ? `I am ${activeAccount}` : undefined,
        beans.length > 0
          ? ` and I own Bean${beans.length > 1 ? 's' : ''} ${beans.join(', ')}`
          : undefined,
      ]
        .filter((part: string | undefined) => part)
        .join(' ');
    setMessageToSign(
      initialMessage(extractOwnedBeanIdsFromBeansIndex(activeAccount, data))
    );
  }, [data, activeAccount]);

  return (
    <div className={clsx(classes.verifyBlock)}>
      <Section fullWidth={true}>
        <Col lg={{ span: 12, offset: 3 }}>
          {messageToSign === undefined ? (
            loadingContent()
          ) : (
            <>
              <h2>SIGN MESSAGE</h2>
              <div>
                <Form.Group
                  className='mb-3'
                  controlId='exampleForm.ControlTextarea1'
                >
                  <Form.Label>MESSAGE TO SIGN:</Form.Label>
                  <Form.Control
                    as='textarea'
                    rows={5}
                    onChange={(e) => setMessageToSign(e.target.value)}
                    defaultValue={messageToSign}
                  />
                </Form.Group>
                <Button
                  onClick={async () => {
                    const signature = await signMessageAsync({
                      message: messageToSign,
                    });
                    setSignedMessage({
                      message: messageToSign,
                      signer: activeAccount,
                      signature,
                    });
                  }}
                >
                  SIGN MESSAGE
                </Button>
              </div>
              <div className={classes.signedPayload}>
                {signedMessage && (
                  <Form.Group
                    className='mb-3'
                    controlId='exampleForm.ControlTextarea1'
                  >
                    <Form.Label>SIGNED PAYLOAD:</Form.Label>
                    <Form.Control
                      as='textarea'
                      rows={5}
                      readOnly={true}
                      value={JSON.stringify(signedMessage)}
                    />
                  </Form.Group>
                )}
              </div>
            </>
          )}
        </Col>
        <Col lg={{ span: 6, offset: 3 }}>
          <VerifySignature />
        </Col>
      </Section>
    </div>
  );
}
